import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { usersApi, type UserSummary } from "../../api/users";
import type { UnlinkedUser } from "../../types/domain";

export const userKeys = {
  all: ["users"] as const,
  list: () => ["users", "list"] as const,
  unlinked: (includedUserId: number | null | undefined) =>
    ["users", "unlinked", includedUserId ?? null] as const,
};

export const useUsers = () =>
  useQuery<UserSummary[]>({
    queryKey: userKeys.list(),
    queryFn: usersApi.list,
  });

type UnlinkedQueryOptions = Omit<
  UseQueryOptions<UnlinkedUser[], Error, UnlinkedUser[], ReturnType<typeof userKeys.unlinked>>,
  "queryKey" | "queryFn"
>;

export const useUnlinkedUsers = (
  includedUserId: number | null | undefined,
  options: Partial<UnlinkedQueryOptions> = {},
) =>
  useQuery({
    queryKey: userKeys.unlinked(includedUserId),
    queryFn: () => usersApi.fetchUnlinked(includedUserId),
    ...options,
  });
